/* eslint-disable @typescript-eslint/no-explicit-any */
type propType = {
  formik: any;
  formType: 'candidate' | 'guarantor';
};

const checkAccordionErrors = (props: propType): boolean => {
  const { formik, formType } = props;

  if (formType === 'candidate') {
    return (
      (formik.touched.monthlyIncome && formik.errors.monthlyIncome) ||
      (formik.touched.studentFinance && formik.errors.studentFinance) ||
      (formik.touched.pep && formik.errors.pep)
    );
  }

  if (formType === 'guarantor') {
    return formik.touched.pep && formik.errors.pep;
  }

  return false;
};

const checkAccordionChecked = (props: propType): boolean => {
  const { formik, formType } = props;
  const accordionError = checkAccordionErrors(props);

  if (formType === 'candidate') {
    return (
      !accordionError &&
      formik.values.monthlyIncome &&
      formik.values.studentFinance === 'true' &&
      formik.values.pep !== ''
    );
  }

  if (formType === 'guarantor') {
    return !accordionError && formik.values.pep !== '';
  }

  return false;
};

export { checkAccordionChecked, checkAccordionErrors };
